import React, { useState } from "react";
import "./Input.css";

interface InputProps
  extends Omit<React.InputHTMLAttributes<HTMLInputElement>, "onChange"> {
  label?: string;
  labelClassName?: string;
  onChange?: (value: string) => void;
  withSearch?: boolean;
  onSearchClick?: () => void;
}

const Input: React.FC<InputProps> = ({
  label,
  labelClassName = "",
  type = "text",
  name,
  value,
  onChange,
  placeholder,
  readOnly = false,
  disabled = false,
  autoFocus = false,
  maxLength,
  minLength,
  required = false,
  pattern,
  className = "",
  style,
  id,
  onBlur,
  onFocus,
  withSearch = false,
  onSearchClick,
  ...rest
}) => {
  const inputId =
    id || name || `input-${Math.random().toString(36).substr(2, 9)}`;

  const [showPassword, setShowPassword] = useState(false);
  const isPasswordField = type === "password";

  return (
    <div className="input-container">
      {label && (
        <label htmlFor={inputId} className={`input-label ${labelClassName}`}>
          {label} {required && <span className="required">*</span>}
        </label>
      )}
      <div className="input-wrapper">
        <input
          id={inputId}
          type={isPasswordField && showPassword ? "text" : type}
          name={name}
          value={value}
          onChange={(e) => onChange?.(e.target.value)}
          placeholder={placeholder}
          readOnly={readOnly}
          disabled={disabled}
          maxLength={maxLength}
          minLength={minLength}
          required={required}
          pattern={pattern}
          className={`input-field ${className}`}
          style={style}
          onBlur={onBlur}
          onFocus={onFocus}
          {...rest}
        />
        {withSearch && (
          <button
            type="button"
            className="search-button"
            onClick={onSearchClick}
          >
            🔍
          </button>
        )}
        {/* {isPasswordField && (
          <button
            type="button"
            className="toggle-password-button"
            onClick={() => setShowPassword((prev) => !prev)}
            tabIndex={-1}
          >
            {showPassword ? "🙈" : "👁️"}
          </button>
        )} */}
      </div>
    </div>
  );
};

export default Input;
